module.exports = __webpack_public_path__ + "img/rod_02.85091415.svg";